module.exports = __webpack_public_path__ + "public/images/shedule-kp.73145799c10b00823e972d40cff33284.png";